import $ from "jquery";
import { debounce } from "../utils/functions";

const $window = $(window);
const $page = $(".page");
const $body = $(".page__body");
const $header = $(".header");
let pageIsTop = true;

$(function () {
  pageScrolled(true);
  $body.on("scroll", pageScrolled);
});

const pageScrolled = (force = false) =>
  $body.scrollTop() > 0 ? pageScrolledHandler(force) : pageTopHandler(force);

const pageScrolledHandler = (force = false) => {
  if (pageIsTop === true || force === true) {
    pageIsTop = false;
    $page.addClass("page--scrolled");
  }
};

const pageTopHandler = (force = false) => {
  if (pageIsTop === false || force === true) {
    pageIsTop = true;
    $page.removeClass("page--scrolled");
  }
};

/* ------------------------------------------------------ */

const MAIN_MENU_HIDDEN_CLASS = "header__scroll-down";

const hasScrolled = {
  down: false,
  up: false,
};
const DELTA = 5;

const menuIsHidden = () => $header.hasClass(MAIN_MENU_HIDDEN_CLASS);

const hideMenu = () => {
  if (!menuIsHidden()) {
    $header.addClass(MAIN_MENU_HIDDEN_CLASS);
    $header.attr("aria-hidden", "true");
  }
};

const showMenu = () => {
  if (menuIsHidden()) {
    $header.removeClass(MAIN_MENU_HIDDEN_CLASS);
    $header.attr("aria-hidden", "false");
  }
};

const handleScroll = () => {
  let lastScrollTop = $body.scrollTop() ?? 0;

  setInterval(() => {
    const scrollTop = $body.scrollTop() ?? 0;

    if (hasScrolled.down) {
      if (Math.abs(lastScrollTop - scrollTop) > DELTA) {
        if (scrollTop > ($header.outerHeight() ?? 0)) {
          hideMenu();
        }
      }
    } else if (hasScrolled.up) {
      if (Math.abs(lastScrollTop - scrollTop) > DELTA) {
        showMenu();
      }
    }

    hasScrolled.down = false;
    hasScrolled.up = false;
    lastScrollTop = scrollTop;
  }, 250);
};

const handleScrollDown = () => (hasScrolled.down = true);

const handleScrollUp = () => {
  hasScrolled.up = true;
  if (($body.scrollTop() ?? 0) <= ($header.outerHeight() ?? 0)) {
    showMenu();
  }
};

/* ------------------------------------------------------ */

// handleScroll();

// $window.on("scroll:down", handleScrollDown);
// $window.on("scroll:up", handleScrollUp);

$window.on(
  "resize",
  debounce(() => $header.css("transition", "unset"), true)
);
$window.on("resize", () => (menuIsHidden() ? hideMenu() : showMenu()));
$window.on(
  "resize",
  debounce(() => $header.css("transition", ""))
);
